import React from 'react';
import { ArrowLeftRight, Zap } from 'lucide-react';

const MixerControls = ({ 
  crossfader, 
  onCrossfaderChange, 
  deckA, 
  deckB,
  mode,
  syncEnabled,
  onSyncToDeckA,
  onSyncToDeckB
}) => {
  // Calculate VU meter levels (simulated based on volume and playing state)
  const getVULevel = (deck) => {
    if (!deck.isPlaying) return 0;
    // Simulate audio levels
    const baseLevel = deck.volume * 0.7;
    const variation = Math.random() * 0.3;
    return Math.min(1, baseLevel + variation);
  };
  
  const vuLevelA = getVULevel(deckA);
  const vuLevelB = getVULevel(deckB);
  
  // Calculate required pitch adjustment to sync BPMs
  const canSync = deckA.bpm && deckB.bpm;
  
  return (
    <div className="mixer-controls" data-testid="mixer-controls">
      {/* VU Meters */}
      <div className="vu-meters">
        <div className="vu-meter vu-a">
          <div className="vu-label">A</div>
          <div className="vu-track">
            <div 
              className="vu-fill"
              style={{ height: `${vuLevelA * 100}%` }}
            />
            <div className="vu-segments">
              {[...Array(10)].map((_, i) => (
                <div 
                  key={i} 
                  className={`vu-segment ${i > 6 ? 'red' : i > 4 ? 'yellow' : 'green'}`}
                />
              ))}
            </div>
          </div>
        </div>
        
        <div className="vu-meter vu-b">
          <div className="vu-label">B</div>
          <div className="vu-track">
            <div 
              className="vu-fill"
              style={{ height: `${vuLevelB * 100}%` }}
            />
            <div className="vu-segments">
              {[...Array(10)].map((_, i) => (
                <div 
                  key={i} 
                  className={`vu-segment ${i > 6 ? 'red' : i > 4 ? 'yellow' : 'green'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Sync Button - Syncs Deck B to match Deck A's BPM */}
      <div className="sync-section">
        <button 
          className={`sync-btn ${syncEnabled ? 'active' : ''}`}
          disabled={!canSync}
          onClick={onSyncToDeckA}
          title={syncEnabled ? "Click to disable sync" : "Sync Deck B to match Deck A's BPM"}
          data-testid="sync-btn"
        >
          <Zap size={14} />
          SYNC
          {syncEnabled && <span className="sync-indicator">ON</span>}
        </button>
        {deckA.bpm && deckB.bpm ? (
          <div className="bpm-display">
            <span className="bpm-a">{Math.round(deckA.bpm)}</span>
            <span className="bpm-arrow">→</span>
            <span className="bpm-b">{Math.round(deckB.bpm)}</span>
          </div>
        ) : (
          <div className="bpm-diff">Load tracks with BPM</div>
        )}
      </div>
      
      {/* Crossfader */}
      <div className="crossfader-section">
        <div className="crossfader-labels">
          <span className={crossfader < 0.3 ? 'active' : ''}>A</span>
          <ArrowLeftRight size={12} />
          <span className={crossfader > 0.7 ? 'active' : ''}>B</span>
        </div>
        
        <div className="crossfader-track">
          <input 
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={crossfader}
            onChange={(e) => onCrossfaderChange(parseFloat(e.target.value))}
            className="crossfader-slider"
          />
          <div className="crossfader-center-mark" />
        </div>
        
        <div className="crossfader-value">
          {crossfader < 0.45 ? 'A' : crossfader > 0.55 ? 'B' : 'MIX'}
        </div>
      </div>
    </div>
  );
};

export default MixerControls;
